export default `
	headline
	featuredArtists {
		...on FeaturedArtistsItem {
			artistName
			talent
			instagram
			image {
				filename
				height
				id
				size
				url(transform:card)
				width
			}
		}
	}
`;
